import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Button } from "../catalyst/button";
import type { ButtonProps } from "../catalyst/button";
import { useState } from "react";

export function ActionableButton({
  children,
  onClick,
  loader,
  ...props
}: {
  children: React.ReactNode;
  loader?: React.ReactNode | string;
  onClick: () => Promise<void> | void;
} & ButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    Promise.resolve(setIsLoading(true))
      .then(onClick)
      .catch(() => null)
      .finally(() => setIsLoading(false));
  };

  const loaderElement = loader ?? (
    <>
      <ArrowPathIcon className="w-4 h-4 animate-spin" /> Loading...
    </>
  );

  return (
    <Button onClick={handleClick} disabled={isLoading} {...props}>
      {isLoading ? loaderElement : children}
    </Button>
  );
}
